import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../RootReducer";
import {CasinoGameInfo, CurrencyDefinition, Jackpot} from "../../http/protocol";
import "./styles/CarouselComponent.scss";
import Carousel from "react-bootstrap/Carousel";
import {prettyUrl} from "../../utils/UrlUtils";
import {RouteComponentProps, useHistory, withRouter} from "react-router-dom";
import {CasinoBannerPayload, ContentModelName, Panel} from "../../contenful/types";
import {fetchAndParseContent} from "../../contenful/ContentfulActions";
import {getContainer} from "../../ioc/IOCSetup";
import {t} from "../../i18n";
import {
    BannerJackpotAmount,
    CasinoGameBanners,
    getCasinoGameBanners,
    getSelectedPageId
} from "../../selectors/casino-selectors";
import {BrandA} from "../../ui/buttons/buttons";
import {ContentStatus} from "../../contenful/ContentfulReducer";
import {getStatusForContent} from "../../selectors/content-selectors";
import {getLoggedIn} from "../../selectors/user-selectors";
import useOnScreen, {usePrevious} from "../../user/ui/utils";
import CurrencyFormatter from "../../utils/CurrencyFormatter";
import App from "../../App";
import { isMobile } from 'react-device-detect';


interface Props extends RouteComponentProps<{tabId?: string, pageId?: string}> {
    loggedIn?: boolean;
    banners?: CasinoGameBanners;
    fetchBanners? : () => void;
    contentStatus?: ContentStatus;
}

interface State {
    index: number;
    pageChanged: boolean;
}


export const CarouselComponent = (props : Props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const status = useSelector((app : AppState) => getStatusForContent(app, ContentModelName.CASINO_PAGE));
    const pageId = useSelector((app : AppState) => getSelectedPageId(app));
    const [state,setState] = useState<State>({index : 0, pageChanged : false});
    const banners = useSelector((app : AppState) => getCasinoGameBanners(app));
    const loggedIn = useSelector((app : AppState) => getLoggedIn(app));
    const pageSelected = useSelector((app : AppState) => app.casino.pageSelected);

    useEffect(()=>{
        dispatch(fetchAndParseContent(ContentModelName.CASINO_PAGE, getContainer().getSettingsService().getActiveLocale().code, true) as any);
    },[dispatch]);

    const prevPageId = usePrevious(pageId);
    useEffect(()=>{
        if(state.index != 0 && prevPageId != pageId) {
            setState({ index: 0, pageChanged : true});
            setTimeout(()=> setState({ index : 0, pageChanged : false}),50);
        }
    },[pageId, prevPageId, state])



    const launchGame = (game: CasinoGameInfo)=> {
        if(loggedIn) {
            if(game && game.name) {
                history.push(`/casino/play/${game.id}/${prettyUrl(game.name)}`)
            }
        } else {
            if(game.playForFun && game.name) {
                history.push(`/casino/play/${game.id}/${prettyUrl(game.name)}`, {playForFun:true})

            } else {
                history.push("/playnow");
            }
        }
    }

    const handleSelect = (selectedIndex: number, e: any) => {
        setState({ index: selectedIndex, pageChanged : false });
    };

    if(status == ContentStatus.IN_PROGRESS || status == ContentStatus.NONE || state.pageChanged == true || !pageSelected) {
        return  <div className={"carousel-loader"}></div>
    }

    if(!banners || !banners.banners || banners.banners.length == 0) {
        return <></>
    }
    return (
        <div className={`${isMobile ? "casino-carousel" : ""}`}>
            <Carousel activeIndex={state.index} onSelect={handleSelect}>
                {
                    banners?.banners?.map((b : CasinoBannerPayload, index) => {
                        let bannerGame =  banners?.bannerGames?.find((bg : CasinoGameInfo) => bg.id == b.gameId);
                        let hasMobileImage = b.mobileImage && b.mobileImage.fields != undefined ? 'has-mobile-image' : ''
                        return (
                            <Carousel.Item key={index + "" + b.title}>
                                <div className={`carousel-background ${hasMobileImage}`} style={{backgroundImage : `url(${b.backgroundImage?.fields?.file?.url ?? ""})`}}>
                                </div>
                                <div className={`carousel-bannerContent ${hasMobileImage}`}>
                                    <div className={`carousel-innerContent ${hasMobileImage}`}>
                                        {b.smallImage && b.smallImage.fields &&
                                            <div className={`imageInnerContainer carousel-smallImage`}>
                                                <img src={b.smallImage.fields.file.url} className={`imageInner`} alt={`imageInner`} />
                                            </div>
                                        }
                                        {b.mobileImage && b.mobileImage.fields &&
                                            <div onClick={()=>bannerGame && launchGame(bannerGame)} className={`imageMobileContainer carousel-mobileImage`}>
                                                <img src={b.mobileImage.fields.file.url} className={`imageMobile`} alt={`Mobile Image`} />
                                            </div>
                                        }
                                        <div className={`carousel-textContent ${hasMobileImage}`}>
                                            {b.title && <h3>{b.title}</h3>}
                                            {b.content && <p>{b.content}</p>}
                                            <BannerJackpot banner={b} jackpots={banners?.jackpots} />
                                            {b.gameId && bannerGame && (
                                                <div className={"carousel-playButtonContainer"}>
                                                    <BrandA className={"btn btn-cta small"} onClick={()=> bannerGame && launchGame(bannerGame)}>
                                                        {t("casino.playGame")}
                                                    </BrandA>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Carousel.Item>
                        )
                    })
                }
            </Carousel>
        </div>
    )
}
export const BannerJackpot = (props : { banner : CasinoBannerPayload | Panel, jackpots : BannerJackpotAmount[]}) => {
    let b = props.banner;
    let jackpots = props.jackpots;
    if(!b.jackpotId || !jackpots || jackpots.length == 0) {
        return <></>;
    }
    let jackpot = jackpots.find(j => j.id === b.jackpotId && b.jackpotCurrency == j.jackpotCurrency);
    if(!jackpot || !jackpot.amount || !jackpot.currency) {
       return <></>
    }
    return (
        <div className={"banner-jackpot"}>
            <span className={"banner-jackpot-label"}>{t("casino.jackpot")}</span>
            <span className={"banner-jackpot-amount"}>
                <JackpotCounter amount={jackpot.amount} currency={jackpot.currency} />
            </span>
        </div>
    )
}

export const JackpotCounter = (props : { amount : number, currency : CurrencyDefinition}) => {

    const [current, setCurrent] = useState({ amount : props.amount * 0.99, count : 1})
    const ref = useRef<HTMLElement>(null);
    const isVisible = useOnScreen(ref)
    const prev = usePrevious(current);
    useEffect(()=>{
        if(!isVisible) {
            return;
        }
        if(current.amount < props.amount) {
            setTimeout(() =>{
                setCurrent({ amount : current.amount + 123, count: current.count+1})

            }, 50 );//5 * Math.log2(current.count));
        } else if(prev?.amount != current.amount) {
            setCurrent({ amount : props.amount, count: current.count});
        }
    },[current,isVisible])

    return (
        <div className={"jackpot-counter-container"} ref={ref as any}>
            <span className={"jackpot-number-group"}>
                <span  className={"jackpot-number-container"}>
                    <span className={"jackpot-amount"}>
                        {CurrencyFormatter.jackpotFormat(props.currency, current.amount)}
                    </span>
                </span>
            </span>
        </div>
    )
}
export default withRouter(CarouselComponent);